import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export const { thunk: relistListings, slice: relistListingsSlice } = getThunkAndSlice<
	{
		ListingIds: Array<number>;
	},
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/RelistListings",
	method: "post",
});
